// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2Hxm_","title":"ClientInsurance_title__2oF9E","itemText":"ClientInsurance_itemText__110Vr"};